import script from "./ProjectWorkspace.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectWorkspace.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectWorkspace.vue?vue&type=style&index=0&id=21725580&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21725580"]])

export default __exports__